"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveGameService = void 0;
const TokenHistory_1 = require("../models/history/TokenHistory");
const api_1 = require("./api");
const PATH = 'interactive/api/game';
class InteractiveGameService {
    static async startGame(digitalRevealToken) {
        try {
            return await api_1.API.put({
                url: `${PATH}/start`,
                body: {
                    digitalRevealToken
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async endGame(digitalRevealToken) {
        try {
            return await api_1.API.put({
                url: `${PATH}/end`,
                body: { digitalRevealToken }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async skipGame(digitalRevealToken) {
        try {
            return await api_1.API.put({
                url: `${PATH}/skip`,
                body: {
                    digitalRevealToken
                }
            });
        }
        catch (error) {
            throw error;
        }
    }
    static async getPlayableTokens(size = 20, page = 0) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/playable`,
                query: { size, page }
            });
            return {
                data: TokenHistory_1.TokenHistory.toJsonList(response.content),
                page: {
                    last: response.last,
                    first: response.first,
                    totalElements: response.totalElements,
                    totalPages: response.totalPages,
                    number: response.number
                }
            };
        }
        catch (e) {
            throw e;
        }
    }
    static async generatePlayForFunToken(digitalReveal, prizes) {
        try {
            return await api_1.API.put({
                url: `${PATH}/play-for-fun/${digitalReveal}`,
                body: prizes
            });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.InteractiveGameService = InteractiveGameService;
//# sourceMappingURL=interactive-game-service.js.map